import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import modules from './modules'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: 'smartphoenix-truck-tracking',
  reducer : state =>({
    users: state.users,
    freightforwarders:state.freightforwarders,
    languages:state.entities.entities['language'],
    entities:{
      loading:state.entities.loading,
      'entities':{
        'language':state.entities.entities['language'],
        'truck':state.entities.entities['truck'],
        'driver':state.entities.entities['driver'],
        'mobilePhone':state.entities.entities['mobilePhone'],
        'deliveryAddress':state.entities.entities['deliveryAddress'],
        'wayBill':state.entities.entities['wayBill'],
        'geoRegion':state.entities.entities['geoRegion'],
        'pending_wayBill':state.entities.entities['pending_wayBill']
      },
      'current_entity':{
        'language':state.entities.current_entity['language'],
        'truck':state.entities.current_entity['truck'],
        'driver':state.entities.current_entity['driver'],
        'mobilePhone':state.entities.current_entity['mobilePhone'],
        'deliveryAddress':state.entities.current_entity['deliveryAddress'],
        'wayBill':state.entities.current_entity['wayBill'],
        'geoRegion':state.entities.current_entity['geoRegion'],
        'pending_wayBill':state.entities.current_entity['pending_wayBill']
      },
      'selected_search_entity':{
        'language':state.entities.selected_search_entity['language'],
        'truck':state.entities.selected_search_entity['truck'],
        'driver':state.entities.selected_search_entity['driver'],
        'mobilePhone':state.entities.selected_search_entity['mobilePhone'],
        'deliveryAddress':state.entities.selected_search_entity['deliveryAddress'],
        'wayBill':state.entities.selected_search_entity['wayBill'],
        'geoRegion':state.entities.selected_search_entity['geoRegion'],
        'pending_wayBill':state.entities.selected_search_entity['pending_wayBill'],
      }
    },
    dashboard: state.dashboard
  })
})

Vue.use(Vuex)

const store = {
  modules,
  getters: {
    globalLoading: (state) => Object.values(state).map(m => m.loading).reduce((l, i) => l || i)
  },
  plugins: [vuexLocal.plugin]
}

export default new Vuex.Store(store)